import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-verify-card-status',
    templateUrl: './verify-card-status.component.html',
    styleUrls: ['./verify-card-status.component.scss'],
    standalone: false
})
export class VerifyCardStatusComponent implements OnInit {
 isVerificationFailed = false;
  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    const status = this.activatedRoute.snapshot.queryParamMap.get("verificationFailed");
    if(status){
      this.isVerificationFailed = true;
    }
    else{
      this.isVerificationFailed = false;
    }
  }

}
